// project import
import Navigation, { BottomNavigation } from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';
import { useSelector } from 'react-redux';
import { RootStateProps } from '../../../../types/root';
import MobileAppDownload from '../MobileAppDownload';
// import { ExperimentOutlined, CloseOutlined, InfoCircleFilled } from '@ant-design/icons';
// import { FormattedMessage } from 'react-intl';
// import NavGroup from './Navigation/NavGroup';
import { Box } from '@mui/material';
// import { Grid } from '@mui/material';
import React, { useEffect } from 'react';
import useAuth from '../../../../hooks/useAuth';
// import { config } from 'env';
// import { NavItemType } from 'types/menu';
// import MainCard from 'components/MainCard';
// import IconButton from 'components/@extended/IconButton';
// import { Alert } from '@mui/material';
// import { useLocation } from 'react-router';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => {
  const { user } = useAuth();
  const menu = useSelector((state: RootStateProps) => state.menu);
  const { drawerOpen } = menu;

  // const [featureRequestAvailable, setFeatureRequestAvailable] = useState(false);
  // const [openModal, setOpenModal] = useState(false);
  // const [scriptLoaded, setScriptLoaded] = useState(false);
  // const [changedLogs, setChangedLogs] = useState('');

  useEffect(() => {
    // const adminRole = user?.roles?.includes('Admin');
    // const paidUserRole = user?.roles?.includes('Paid Member');
    // setFeatureRequestAvailable(adminRole === true || paidUserRole === true);
    // initChangelogfy(adminRole || false, paidUserRole || false);
  }, [user]);

  return (
    <>
      {/* Scrollable Navigation Area */}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <SimpleBar
          style={{
            height: '100%',
            overflowX: 'hidden'
          }}
          sx={{
            flex: 1,
            minHeight: 0,
            '& .simplebar-content-wrapper': {
              height: '100%'
            },
            '& .simplebar-content': {
              height: '100%'
            }
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            {/* Main Navigation - Scrollable Area */}
            <Box sx={{ flexGrow: 1 }}>
              <Navigation />
            </Box>

            {/* Bottom Sections - Fixed at Bottom */}
            <Box sx={{ flexShrink: 0 }}>
              <BottomNavigation />
              {drawerOpen && <MobileAppDownload />}
            </Box>
          </Box>
        </SimpleBar>
      </Box>
    </>
  );
};
export default DrawerContent;
